<section class="articles-hero">
  <h2 class="heading-1 articles-hero__title">
    <noda-translate key="articles.main.title" />
  </h2>
  <div class="articles-hero__tags">
    <noda-tags [tags]="tags()" />
  </div>
  <noda-articles-banner [needLink]="true" />
  <noda-articles-payment />
</section>
